import { render, staticRenderFns } from "./ContactsReferentList.vue?vue&type=template&id=2390af18&scoped=true&"
import script from "./ContactsReferentList.vue?vue&type=script&lang=js&"
export * from "./ContactsReferentList.vue?vue&type=script&lang=js&"
import style0 from "./ContactsReferentList.vue?vue&type=style&index=0&id=2390af18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390af18",
  null
  
)

export default component.exports